const SOCKET_HEART_TIME = 25 // 保持连接心跳秒数 0 则不保持心跳连接
const install = (Vue) => {
  // socket 连接池
  Vue.prototype.$sockets = {
    pools: {},
    hearts: {},
    createConnect: function (
      linkId,
      others = null,
      onMessage = null,
      onOpen = null,
      onClose = null,
      onError = null
    ) {
      let wssUrl = `wss://ws.xbeduc.com?link_id=${linkId}`
      // 追加其他参数
      if (!others || typeof others !== 'object') others = {}
      for (let i in others) {
        wssUrl += `&${i}=${others[i]}`
      }
      let token = localStorage.getItem('user-token')
      if (!others.token && token) wssUrl += `&token=${token}`
      this.pools[linkId] = new WebSocket(wssUrl)
      //定义 打开事件 的回调,当连接ws成功后,会调用执行这个回调函数
      this.pools[linkId].onopen = () => {
        this.handleHeart(linkId)
        if (onOpen && typeof onOpen == 'function') {
          onOpen(linkId)
        }
      }
      //定义 服务器发送消息 的回调,当服务器主动发送消息到客户端时,会调用执行这个回调函数
      this.pools[linkId].onmessage = (e) => {
        // console.log('接收到服务端的消息', linkId, e.data)
        if (onMessage && typeof onMessage == 'function') {
          onMessage(e.data)
        }
      }
      this.pools[linkId].onerror = (e) => {
        // console.log('链接建立失败', linkId, e)
        if (onError && typeof onError == 'function') {
          onError(e)
        }
      }
      //定义 关闭连接 的回调,当连接关闭(服务端关闭,客户端关闭,网络断开等原因),会调用执行这个回调函数
      this.pools[linkId].onclose = (params) => {
        // console.log('连接被关闭', linkId, params)
        if (onClose && typeof onClose == 'function') {
          onClose(params)
        }
      }
    },
    getQueryParams: function (url) {
      const theRequest = new Object()
      let str = url.split('?')[1] || ''
      if (str) {
        let strs = str.split('&')
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1]
        }
      }
      return theRequest
    },
    // 读取链接参数
    getLinkParams(linkId) {
      if (!this.pools[linkId] || this.pools[linkId].readyState != 1) {
        return null
      }
      let params = this.getQueryParams(this.pools[linkId].url)
      return params
    },

    // 执行心跳数据发送
    handleHeart: function (linkId) {
      if (SOCKET_HEART_TIME <= 0) {
        return false
      }
      if (this.pools[linkId] && this.pools[linkId].readyState == 1) {
        if (this.hearts[linkId]) {
          clearTimeout(this.hearts[linkId])
        }
        this.hearts[linkId] = setTimeout(() => {
          this.send(linkId, '1')
        }, SOCKET_HEART_TIME * 1000)
      } else {
        if (this.hearts[linkId]) {
          clearTimeout(this.hearts[linkId])
          delete this.hearts[linkId]
        }
      }
    },

    // 关闭对应连接
    closeConnect: function (linkId) {
      if (this.pools[linkId] && this.pools[linkId].readyState == 1) {
        this.pools[linkId].close()
      }
      if (this.hearts[linkId]) {
        clearTimeout(this.hearts[linkId])
        delete this.hearts[linkId]
      }
    },

    // 断开所有连接
    closeConnectAll: function () {
      if (this.pools) {
        for (let linkId in this.pools) {
          this.closeConnect(linkId)
        }
      }
    },

    // 向连接发送数据
    send: function (linkId, data, success = null, error = null) {
      let doSend = (ws, callback = null) => {
        // console.info('发送数据：' + data, new Date())
        ws.send(data)
        this.handleHeart(linkId)
        if (typeof callback == 'function') callback()
      }
      if (!this.pools[linkId] || this.pools[linkId].readyState > 1) {
        if (typeof error == 'function') error(2) // 返回2 表示连接断线
      } else if (this.pools[linkId].readyState == 0) {
        if (typeof error == 'function') error(1) // 返回1 表示连接缓冲
      } else {
        // 连接正常 执行发送
        doSend(this.pools[linkId], success)
      }
    },

    // 向连接发送数据（自动重连）
    sendAutoCreate: function (
      linkId,
      data,
      reConnect = false,
      success = null,
      createOther = null
    ) {
      if (!this.pools[linkId] || this.pools[linkId].readyState > 1) {
        // 连接已失效，建立重连并发送
        if (reConnect) {
          this.createConnect(
            linkId,
            createOther,
            () => {},
            () => {
              this.send(linkId, data, success)
            }
          )
        }
      } else if (this.pools[linkId].readyState == 0) {
        // 正在连接时，重写连接建立回调
        this.pools[linkId].onopen = () => {
          this.send(linkId, data, success)
        }
      } else {
        // 连接正常 执行发送
        this.send(linkId, data, success)
      }
    },
  }
}

export default {
  install,
}
